import React from "react";
import { MGTypography, TMGTypographyProps } from "../MGTypography/MGTypography";
import { MGLabelStyleDefinitions, TMGLabelStyleDefinitions } from "../../typography";

export type TMGLabelProps = TMGTypographyProps & {
  labelStyleDefinition: TMGLabelStyleDefinitions;
};

export const MGLabel = ({ labelStyleDefinition, ...props }: TMGLabelProps) => (
  <MGTypography
    {...props}
    componentName="mg-label"
    definition={MGLabelStyleDefinitions[labelStyleDefinition]}
  />
);
